const VUE_APP_API_KNOWLEDGE_URL = document.querySelector("html").getAttribute("api_knowledge_url");

export default VUE_APP_API_KNOWLEDGE_URL